import { render, staticRenderFns } from "./edit-basic-information.vue?vue&type=template&id=018c4bdb&scoped=true&"
import script from "./edit-basic-information.vue?vue&type=script&lang=js&"
export * from "./edit-basic-information.vue?vue&type=script&lang=js&"
import style0 from "./edit-basic-information.vue?vue&type=style&index=0&id=018c4bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c4bdb",
  null
  
)

export default component.exports